export default [
  {
    path: '/context',
    component: { render (createElement) { return createElement('router-view') } },
    meta: {
      noContextRequired: true
    },
    children: [
      {
        path: '',
        name: 'contextSelection',
        component: () => import(/* webpackChunkName: "context" */ '@/views/Context/Context.vue')
      }, {
        path: 'apply',
        name: 'applyContext',
        component: () => import(/* webpackChunkName: "context" */ '@/views/Context/Apply.vue'),
        props: true
      }
    ]
  }
]
